import React, { useEffect, useState } from 'react'
// Import selectors & action from setting store
import * as SettingSelector from '../../../../store/setting/selectors'

// Redux Selector / Action
import { useSelector } from 'react-redux';

//components
import Verticalnav from './verticalnav'
import Scrollbar from 'smooth-scrollbar'

const MOBILE_BREAKPOINT = 1200;

const Sidebar = ({ notificationCount }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const sidebarType = useSelector(SettingSelector.sidebar_type) // array
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style)

  useEffect(() => {
    const scrollbarEl = document.querySelector('.data-scrollbar');
    if (scrollbarEl) Scrollbar.init(scrollbarEl);

    const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]');

    const handleResize = () => {
      const tabs = document.querySelectorAll('.nav')
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        Array.from(tabs, (elem) => {
          if (!elem.classList.contains('flex-column') && elem.classList.contains('nav-tabs') && elem.classList.contains('nav-pills')) {
            elem.classList.add('flex-column', 'on-resize');
          }
          return elem.classList.add('flex-column', 'on-resize')
        })
        // Close sidebar on resize to mobile
        if (sidebarResponsive) sidebarResponsive.classList.remove('sidebar-open');
        setMobileOpen(false);
      } else {
        Array.from(tabs, (elem) => {
          if (elem.classList.contains('on-resize')) {
            elem.classList.remove('flex-column', 'on-resize');
          }
          return elem.classList.remove('flex-column', 'on-resize');
        })
        if (sidebarResponsive) sidebarResponsive.classList.remove('sidebar-open');
        setMobileOpen(false);
      }
    };

    // Track sidebar-open mutations to sync mobileOpen state for backdrop
    const observer = new MutationObserver(() => {
      if (sidebarResponsive) {
        const isOpen = sidebarResponsive.classList.contains('sidebar-open');
        setMobileOpen(isOpen && window.innerWidth < MOBILE_BREAKPOINT);
      }
    });
    if (sidebarResponsive) {
      observer.observe(sidebarResponsive, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, [])

  const handleBackdropClick = () => {
    const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]');
    if (sidebarResponsive) {
      sidebarResponsive.classList.remove('sidebar-open');
      setMobileOpen(false);
    }
  };

  return (
    <>
      {mobileOpen && (
        <div
          onClick={handleBackdropClick}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.45)',
            zIndex: 909,
          }}
        />
      )}
      <aside className={`${sidebarType.join(" ")} ${sidebarMenuStyle} sidebar sidebar-default sidebar-base navs-rounded-all `} id="first-tour" data-toggle="main-sidebar" data-sidebar="responsive">
        <div className="sidebar-body pt-0 data-scrollbar">
          <div className="sidebar-list">
            <Verticalnav notificationCount={notificationCount} />
          </div>
        </div>
        <div className="sidebar-footer"></div>
      </aside>
    </>
  )
}

export default Sidebar
